<template>
	<div class="range-slider">
		<span class="range-slider__range-track"></span>

		<input
			v-model.number="model"
			type="range"
			:step
			:min
			:max
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type Props = {
	min?: number;
	max?: number;
	step?: number;
};

const props = withDefaults(defineProps<Props>(), {
	min: 0,
	step: 1,
	max: 100,
});
const model = defineModel<number>();

const trackWidth = computed(() => {
	if (!model.value) {
		return 0;
	}
	return `${(100 / (props.max - props.min)) * (model.value - props.min)}%`;
});
</script>

<style lang="scss" scoped>
.range-slider {
	position: relative;
	height: 0.8rem;
	background-color: $color-inactive;
	border-radius: 2rem;

	&__range-track {
		height: 100%;
		position: absolute;
		border-radius: 2rem;
		background-color: $price-slider-track-bg;
		top: 0;
		left: 0;
		width: calc(v-bind('trackWidth'));
	}

	input {
		position: absolute;
		width: 100%;
		height: 0.5rem;
		background: none;
		pointer-events: none;
		appearance: none;
		top: 50%;
		transform: translateY(-50%);
		margin: 0;

		&::-webkit-slider-thumb {
			height: 2.4rem;
			width: 2.4rem;
			border-radius: 50%;
			border: 2px solid $color-primary;
			background-color: $color-white;
			pointer-events: auto;
			appearance: none;
			cursor: pointer;
			margin-bottom: 1px;
		}

		&::-moz-range-thumb {
			height: 2rem;
			width: 2rem;
			border-radius: 50%;
			border: 2px solid $color-primary;
			background-color: $color-white;
			pointer-events: auto;
			appearance: none;
			cursor: pointer;
			margin-top: 30%;
		}
	}
}
</style>
